import { FontStyles } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormInputWithUnit, FormSelect } from "../../../../components/FormFields";

const VolumeDesignUpsell = () => {
    return (
        <div>
            <div id="upsell-product">
                <FormSubSection rowLabel={"Product"}>
                    <FormColorPicker name="bundles_design.upsell_bg_color" label="Selected Background Color" />
                    <FormColorPicker name="bundles_design.upsell_text_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.upsell_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.upsell_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="upsell-price">
                <FormSubSection rowLabel={"Price"}>
                    <FormColorPicker name="bundles_design.upsell_price_color" label="Price Color" />
                    <FormInputWithUnit
                        name="bundles_design.upsell_price_size"
                        min={0}
                        label="Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.upsell_price_style"
                        label="Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="upsell-compare-at-price">
                <FormSubSection rowLabel={"Compare at Price"} hideSeparator>
                    <FormColorPicker name="bundles_design.upsell_compare_price_color" label="Compare-at Price Color" />
                    <FormInputWithUnit
                        name="bundles_design.upsell_compare_price_size"
                        min={0}
                        label="Compare-at Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.upsell_compare_price_style"
                        label="Compare-at Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>
        </div>
    );
};

export default VolumeDesignUpsell;
